import { useLocation } from '@reach/router';
import { parse } from 'query-string';

const useLink = (jobOfferId?: string) => {
  const location = useLocation();
  const source = parse(location.search).utm_source || 'gojob-board';

  if (!jobOfferId) {
    return;
  }

  return `${process.env.FOG_URL}/public-job/accept/${jobOfferId}?source=${source}`;
};

export default useLink;
